import API from '@/shared/plugins/Api/API'

class SqliteV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _appUrl (appName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}`
  }

  async getBackupConfig (appName) {
    return this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/sqlite/backup-config`
    })
  }

  async updateBackupConfig (appName, config) {
    return this.request({
      method: 'put',
      url: `${this._appUrl(appName)}/sqlite/backup-config`,
      data: config
    })
  }

  async listBackups (appName) {
    return this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/sqlite/backup`
    })
  }

  // Synchronous (204 = done); the application must be restarted to pick up the restored file.
  async restoreBackup (appName, backupName) {
    return this.request({
      method: 'post',
      url: `${this._appUrl(appName)}/sqlite/restore`,
      data: { backup: backupName }
    })
  }
}

export default SqliteV3
